export const categories = [
  {
    slug: 'all',
    name: '全部游戏',
    icon: 'ri-gamepad-line',
    description: '浏览NG南宫平台全部正版游戏，涵盖各类热门游戏类型',
    count: 36,
  },
  {
    slug: 'casual',
    name: '休闲益智',
    icon: 'ri-lightbulb-line',
    description: '轻松有趣的休闲益智类游戏，适合打发碎片时间',
    count: 10,
  },
  {
    slug: 'rpg',
    name: '角色扮演',
    icon: 'ri-sword-line',
    description: '沉浸式角色扮演游戏，体验丰富的剧情和冒险世界',
    count: 8,
  },
  {
    slug: 'strategy',
    name: '策略竞技',
    icon: 'ri-brain-line',
    description: '烧脑策略竞技游戏，考验智慧与决策能力',
    count: 7,
  },
  {
    slug: 'board',
    name: '棋牌游戏',
    icon: 'ri-stack-line',
    description: '经典棋牌类游戏合集，随时随地与好友对战',
    count: 6,
  },
  {
    slug: 'sports',
    name: '体育竞速',
    icon: 'ri-speed-up-line',
    description: '热血体育竞速游戏，感受速度与激情的碰撞',
    count: 5,
  },
];